export type ExtractVars<T extends string> = T extends `${string}{{${infer Var}}}${infer Rest}`
  ? Var | ExtractVars<Rest>
  : never

export type InterpolateValues<T extends string> = Record<ExtractVars<T>, string | number>

export function interpolate<T extends string>(template: T, values: InterpolateValues<T>): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => String(values[key as keyof typeof values] ?? ''))
}
